import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';

const ROUTE_META: Record<string, { title: string; subtitle: string }> = {
  '/business-marketplace': { title: 'Khám phá Marketplace', subtitle: 'Mua bán tài khoản Seeding & AI theo mô hình escrow BizTada' },
  '/business-marketplace/sell': { title: 'Đăng bán sản phẩm', subtitle: 'Tạo listing mới — sẽ qua duyệt trước khi công khai' },
  '/business-marketplace/my-listings': { title: 'Sản phẩm của tôi', subtitle: 'Theo dõi trạng thái các sản phẩm bạn đang bán' },
  '/business-marketplace/trades': { title: 'Lịch sử giao dịch', subtitle: 'Toàn bộ giao dịch mua bán qua escrow' },
  '/business-marketplace/withdrawals': { title: 'Rút tiền', subtitle: 'Chuyển Tada Credits sang tài khoản ngân hàng' },
};

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();
  const meta = ROUTE_META[location.pathname] ?? ROUTE_META['/business-marketplace'];

  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: 'var(--color-bg)',
      }}
    >
      <Sidebar />
      <div
        style={{
          marginLeft: '80px',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <header
          style={{
            height: '72px',
            backgroundColor: 'rgba(255,255,255,0.85)',
            backdropFilter: 'blur(8px)',
            borderBottom: '1px solid var(--color-border)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 32px',
            position: 'sticky',
            top: 0,
            zIndex: 10,
            flexShrink: 0,
          }}
        >
          <div>
            <h1
              style={{
                fontSize: '18px',
                fontWeight: 700,
                color: 'var(--color-text-main)',
                lineHeight: 1.2,
                margin: 0,
              }}
            >
              {meta.title}
            </h1>
            <p
              style={{
                fontSize: '13px',
                color: 'var(--color-text-secondary)',
                marginTop: '2px',
                marginBottom: 0,
              }}
            >
              {meta.subtitle}
            </p>
          </div>
        </header>

        {/* Content */}
        <main style={{ flex: 1, overflowY: 'auto', padding: '24px' }}>
          <div
            style={{
              maxWidth: '1200px',
              margin: '0 auto',
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              minHeight: '100%',
            }}
          >
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
